import { forwardRef } from 'react';
import { Link } from '../../../components/Link';
import { SvgTrailer } from '../../../icons';
import { routes } from '../../../routes/route-utils';
import styles from './details-button.module.scss';

interface TrailerButtonProps {
  platformTitleId: string;
  providerIdentifier: string;
}

export const TrailerButton = forwardRef<HTMLAnchorElement, TrailerButtonProps>(
  ({ platformTitleId, providerIdentifier }, ref) => {
    const text = 'Trailer';

    const route = routes.trailer(platformTitleId, providerIdentifier);

    return (
      <Link className={styles.secondary} to={route} ref={ref}>
        <SvgTrailer className={styles.icon} /> {text}
      </Link>
    );
  },
);
